<template>
  <div v-if="videoInitalized">
  <v-card style="height:100vh;width:100%" v-if="!$vuetify.breakpoint.smAndDown">
    <vue-plyr ref="plyr" :options="options" >
        <video autoplay :src="resources[0].url" :style="(!isFullscreen) ? 'height:690px' : 'height:100vh;'">
            <source  :src="resources[0].url" :type="(resources[0].mimeType != null) ? resources[0].mimeType : 'video/mp4'" size="200px">
        </video>
    </vue-plyr>
  </v-card>
  <v-card color="red" style="position:fixed;bottom:60px;top:0px;left:0px;right:0px;" ref="holder" v-else>
    <vue-plyr ref="plyr" :options="options">
        <video controls  crossorigin :src="resources[0].url" :style="videoStyle">
            <source  :src="resources[0].url" :type="(resources[0].mimeType != null) ? resources[0].mimeType : 'video/mp4'" size="100px">
        </video>
    </vue-plyr>
  </v-card>
  </div>
</template>

<script>

import {mapMutations} from 'vuex'


  export default {
    name: 'VideoResourcesView',
    components: {
    },
    props: {

      resources : Array

    },
    computed: {

      videoStyle ()
      {
        if(!this.isFullscreen)
        {
          return 'height:' + this.viewerHeight + 'px;!important';
        }
        else
        {
          return 'height:100vh;!important';
        }
      }

    },

    mounted () {

      if(this.$browserDetect.isIOS)
      {
        this.options.fullscreen.enabled = false;
      }

      this.videoInitalized = true;
      
      if(this.$vuetify.breakpoint.smAndDown)
      {
         window.addEventListener('resize', this.ResizeEvent);

        this.$nextTick(() => {
          if(this.$refs.holder != null)
          {
            this.viewerHeight = this.$refs.holder.$el.clientHeight;
            this.calculatedHeight = true;
          }



          this.$refs.plyr.player.on('enterfullscreen', () => this.OnFullScreen())
          this.$refs.plyr.player.on('exitfullscreen', () => this.OnExitFullScreen())
          this.$refs.plyr.player.on('playing', () => this.OnPlay())
          this.$refs.plyr.player.on('pause', () => this.RaiseAudioVolume())
        
        })

      }
      else
      {
        this.$nextTick(() => {

          this.$refs.plyr.player.on('enterfullscreen', () => this.OnFullScreen())
          this.$refs.plyr.player.on('exitfullscreen', () => this.OnExitFullScreen())
          this.$refs.plyr.player.on('playing', () => this.OnPlay())
          this.$refs.plyr.player.on('pause', () =>  this.RaiseAudioVolume())

        });
      }
     

      
     

    },
    data: () => ({

      videoInitalized : false,
      options: { fullscreen: {enabled : true, iosNative : true} },
      viewerHeight : 100,
      calculatedHeight : false,
      reRenderCaro : 0,
      isFullscreen : false
    }),
    methods: {

      ...mapMutations("sessionState", [
         "LowerAudioVolume",
         "RaiseAudioVolume"
      ]),

      OnPlay()
      {
        this.LowerAudioVolume();
      },

      OnFullScreen()
      {
        this.isFullscreen = true;
      },
      OnExitFullScreen()
      {
        this.isFullscreen = false;
      },

      ResizeEvent()
      {
        if(this.$vuetify.breakpoint.smAndDown)
        {
          clearTimeout(this.$options.resizeTimer);
          this.$options.resizeTimer = setTimeout(this.FinishedResizing, 100);
        }
       
      },
      FinishedResizing()
      {
        if(this.$refs.holder != null)
        {
          this.viewerHeight = this.$refs.holder.$el.clientHeight;
          this.calculatedHeight = true;
          this.reRenderCaro += 1;
        }
      },



    },
    watch: {
      
    }
  }
</script>
